export const homeRoutes = {
  functionRoute: true,
  requiredElements: ['locations', 'pools'],
  route: (locations, pools) => ({
    label: 'home',
    permission: 'web.admin.home',
    children: [
      {
        id: 'dashboard',
        name: 'Dashboard',
        icon: 'squaresFour',
        to: '/dashboard',
        permission: 'web.admin.home.dashboard',
        subscription: ['dashboard'],
        active: true
      },
      // {
      //   id: 'fundamentals',
      //   name: 'Fundamentals',
      //   icon: 'squareHalf',
      //   to: '/fundamentals',
      //   subscription: ['fundamentals'],
      //   permission: 'web.admin.home.fundamentals',
      //   active: true
      // },
      // {
      //   id: 'duckEnergyBox',
      //   name: 'DuckEnergy Box',
      //   icon: 'package',
      //   subscription: ['duckEnergyBox'],
      //   permission: 'web.admin.home:duckEnergyBox',
      //   active: true,
      //   children: [
      //     {
      //       id: 'duckEnergyBoxOverview',
      //       name: 'Overview',
      //       to: '/duckenergy-box/overview',
      //       active: true,
      //       permission: 'web.admin.home.duckEnergyBox.overview',
      //       subscription: ['duckEnergyBoxOverview']
      //     },
      //     {
      //       id: 'requestDuckEnergyBox',
      //       name: 'Request',
      //       to: '/duckenergy-box/request',
      //       active: true,
      //       permission: 'web.admin.home.duckEnergyBox.request',
      //       subscription: ['requestDuckEnergyBox']
      //     },
      //     {
      //       id: 'duckEnergyBoxAdd',
      //       name: 'Add',
      //       to: '/duckenergy-box/add',
      //       active: true,
      //       permission: 'web.admin.home.duckEnergyBox.add',
      //       subscription: ['duckEnergyBoxAdd']
      //     }
      //   ]
      // },
      {
        id: 'locations',
        name: 'Locations',
        icon: 'location',
        active: true,
        permission: 'web.admin.home.locations',
        subscription: [
          'overview',
          ...locations.map(({ name }) => name.toLowerCase())
        ],
        children: [
          {
            id: 'overview',
            name: 'Overview',
            to: '/locations/overview',
            exact: true,
            active: true,
            permission: 'web.admin.home.locations.overview',
            subscription: ['overview']
          },
          ...locations.map(({ id, name }) => {
            return {
              id: id,
              name: name,
              to: `/locations/${id}`,
              exact: true,
              active: true,
              permission: 'web.admin.home.locations.location',
              subscription: [id]
            };
          })
          // {
          //   id: 'addLocation',
          //   name: 'Add Location',
          //   to: '/locations/add-location',
          //   exact: true,
          //   active: true,
          //   permission: 'web.admin.home.locations.add',
          //   subscription: ['addLocation']
          // }
        ]
      },
      {
        id: 'pools',
        name: 'Pools',
        icon: 'sidebar',
        subscription: ['pool'],
        permission: 'web.admin.home.pools',
        active: true,
        children: [
          {
            id: 'poolOverview',
            name: 'Overview',
            to: '/pool/overview',
            active: true,
            permission: 'web.admin.home.pools.overview',
            subscription: ['poolOverview']
          },
          ...pools.map(({ id, name }) => ({
            id,
            name,
            to: `/pool/${id}`,
            exact: true,
            active: true,
            permission: 'web.admin.home.pools.pool',
            subscription: [id]
          }))
          // {
          //   id: 'poolSubAccounts',
          //   name: 'Sub-Accounts',
          //   to: '/pool/sub-accounts',
          //   active: true,
          //   permission: 'web.admin.home.pools.subAccounts',
          //   subscription: ['poolSubAccounts']
          // },
          // {
          //   id: 'poolTransactions',
          //   name: 'Transactions',
          //   to: '/pool/transactions',
          //   active: true,
          //   permission: 'web.admin.home.pools.transactions',
          //   subscription: ['poolTransactions']
          // },
          // {
          //   id: 'poolAdd',
          //   name: 'Add',
          //   to: '/pool/add',
          //   active: true,
          //   permission: 'web.admin.home.pools.add',
          //   subscription: ['poolAdd']
          // }
        ]
      },
      {
        id: 'paymentProviders',
        name: 'Payment Providers',
        icon: 'money',
        active: true,
        subscription: ['paymentProviders'],
        permission: 'web.admin.home:paymentProviders',
        children: [
          {
            id: 'paymentProvidersOverview',
            name: 'Overview',
            to: '/payment-providers/overview',
            active: true,
            permission: 'web.admin.home.paymentProviders.overview',
            subscription: ['paymentProvidersOverview']
          }
          // {
          //   id: 'paymentProvidersAdd',
          //   name: 'Add',
          //   to: '/payment-providers/add',
          //   active: true,
          //   permission: 'web.admin.home.paymentProviders.add',
          //   subscription: ['paymentProvidersAdd']
          // }
        ]
      },
      {
        id: 'accounting',
        name: 'Accounting',
        icon: 'accounting',
        permission: 'web.admin.home.accounting',
        subscription: ['accounting'],
        active: true,
        children: [
          {
            id: 'overview',
            name: 'Overview',
            to: '/accounting',
            active: true,
            permission: 'web.admin.home.accounting.overview',
            subscription: ['overview']
          },
          {
            id: 'allTransactions',
            name: 'All Transactions',
            to: '/all-transactions',
            active: true,
            permission: 'web.admin.home.accounting.allTransactions',
            subscription: ['allTransactions']
          },
          {
            id: 'paymentRequests',
            name: 'Payment Requests',
            to: '/payment-requests',
            active: true,
            permission: 'web.admin.home.accounting.paymentRequests',
            subscription: ['paymentRequests']
          }
        ]
      },
      {
        id: 'duckEnergyFee',
        name: 'DuckEnergy Fees',
        icon: 'handCoins',
        active: true,
        permission: 'web.admin.home.duckEnergyFee',
        subscription: ['feeOverview', 'feeTransactions'],
        children: [
          {
            id: 'feeOverview',
            name: 'Overview',
            to: '/fee/overview',
            active: true,
            permission: 'web.admin.home.duckEnergyFee.overview',
            subscription: ['feeOverview']
          },
          {
            id: 'feeTransactions',
            name: 'Transactions',
            to: '/fee/transactions',
            active: true,
            permission: 'web.admin.home.duckEnergyFee.transactions',
            subscription: ['feeTransactions']
          }
        ]
      }
    ]
  })
};

export const customersRoutes = {
  label: 'customers',
  permission: 'web.admin.customers',
  children: [
    {
      id: 'customers',
      name: 'Customers',
      icon: 'users',
      to: '/customers/all',
      exact: true,
      active: true,
      permission: 'web.admin.customers.all',
      subscription: ['customers']
    },
    {
      id: 'customerAdd',
      name: 'Add Customer',
      icon: 'userPlus',
      to: '/customers/add',
      exact: true,
      active: true,
      permission: 'web.admin.customers.add',
      subscription: ['customerAdd']
    },
    {
      id: 'contracts',
      name: 'Contracts',
      icon: 'contracts',
      to: '/contracts',
      exact: true,
      active: true,
      permission: 'web.admin.customers.contracts',
      subscription: ['contracts']
    },
    {
      id: 'addContract',
      name: 'Add Contract',
      icon: 'addContract',
      to: '/add-contract',
      exact: true,
      active: true,
      permission: 'web.admin.customers.addContract',
      subscription: ['addContract']
    }
  ]
};

export const tasksRoutes = {
  label: 'Tasks',
  permission: 'web.admin.tasks',
  children: [
    {
      id: 'helpDesk',
      name: 'Help Desk',
      to: '/tasks/help-desk',
      icon: 'zendesk',
      exact: true,
      active: true,
      permission: 'web.admin.tasks.helpDesk',
      subscription: ['helpDesk']
    },
    {
      id: 'customerTasks',
      name: 'Customer Tasks',
      to: '/tasks/customer-tasks',
      icon: 'listChecks',
      exact: true,
      active: true,
      permission: 'web.admin.tasks.customerTasks',
      subscription: ['customerTasks']
    },
    {
      id: 'minerTasks',
      name: 'Miner Tasks',
      to: '/tasks/miner-tasks',
      icon: 'network',
      exact: true,
      active: true,
      permission: 'web.admin.tasks.minerTasks',
      subscription: ['minerTasks']
    }
    // {
    //   id: 'tasksApdus',
    //   name: 'APDUs',
    //   to: '/tasks/apdus',
    //   icon: 'memory',
    //   exact: true,
    //   active: true,
    //   permission: 'web.admin.tasks.apdus',
    //   subscription: ['tasksApdus']
    // },
    // {
    //   id: 'tasksNetwork',
    //   name: 'Network',
    //   to: '/tasks/network',
    //   icon: 'vector',
    //   exact: true,
    //   active: true,
    //   permission: 'web.admin.tasks.network',
    //   subscription: ['tasksNetwork']
    // }
  ]
};

export const selfMining = {
  label: 'Self Mining',
  permission: 'web.admin.selfMining',
  children: [
    {
      id: 'selfMiningOverview',
      name: 'Overview',
      icon: 'chartPieSlice',
      to: '/self-mining/overview',
      exact: true,
      active: true,
      permission: 'web.admin.selfMining.overview',
      subscription: ['selfMiningOverview']
    },
    {
      id: 'selfMiningRevenue',
      name: 'Own Revenue',
      icon: 'coins',
      to: '/self-mining/revenue',
      exact: true,
      active: true,
      permission: 'web.admin.selfMining.revenue',
      subscription: ['selfMiningRevenue']
    },
    {
      id: 'selfMiningMiners',
      name: 'Own Miners',
      icon: 'graph',
      to: '/self-mining/miners',
      exact: true,
      active: true,
      permission: 'web.admin.selfMining.miners',
      subscription: ['selfMiningMiners']
    },
    {
      id: 'selfMiningTransactions',
      name: 'Own Transactions',
      icon: 'arrowsLeftRight',
      to: '/self-mining/transactions',
      exact: true,
      active: true,
      permission: 'web.admin.selfMining.transactions',
      subscription: ['selfMiningTransactions']
    }
  ]
};

export const hardwareRoutes = {
  label: 'Hardware',
  permission: 'web.admin.hardware',
  children: [
    {
      id: 'overview',
      name: 'Overview',
      icon: 'chartPie',
      to: '/hardware/overview',
      active: true,
      permission: 'web.admin.hardware.overview',
      subscription: ['overview']
    },
    {
      id: 'allMiners',
      name: 'All Devices',
      icon: 'network',
      to: '/hardware/all-miners',
      active: true,
      permission: 'web.admin.hardware.miners',
      subscription: ['allMiners']
    },
    {
      id: 'addMiner',
      name: 'Add Miner',
      icon: 'cursorClick',
      to: '/hardware/add-miner',
      active: true,
      permission: 'web.admin.hardware.minersAdd',
      subscription: ['addMiner']
    }
    // {
    //   id: 'allAPDUs',
    //   name: 'All APDUs',
    //   icon: 'memory',
    //   to: '/hardware/all-apdus',
    //   active: true,
    //   permission: 'web.admin.hardware.apdus',
    //   subscription: ['allAPDUs']
    // },
    // {
    //   id: 'addAPDU',
    //   name: 'Add APDU',
    //   icon: 'handTap',
    //   to: '/hardware/add-apdu',
    //   active: true,
    //   permission: 'web.admin.hardware.apdusAdd',
    //   subscription: ['addAPDU']
    // }
  ]
};

export const ecommerceRoutes = {
  label: 'E-Commerce',
  permission: 'web.admin.ecommerce',
  children: [
    {
      id: 'ecommerceAddProduct',
      name: 'Add Product',
      icon: 'addProduct',
      to: '/ecommerce/add-product',
      active: true,
      permission: 'web.admin.ecommerce.addProduct',
      subscription: ['ecommerceAddProduct']
    },
    {
      id: 'ecommerceInventory',
      name: 'Inventory',
      icon: 'inventory',
      to: '/ecommerce/inventory',
      active: true,
      permission: 'web.admin.ecommerce.inventory',
      subscription: ['ecommerceInventory']
    },
    // nav removed (2026-08 frontend audit): price-group backend does not exist
    // {
    // id: 'ecommerceHostingPrices',
    // name: 'Hosting Prices',
    // icon: 'hostingPrices',
    // to: '/ecommerce/hosting-prices',
    // active: true,
    // permission: 'web.admin.ecommerce.hostingPrices',
    // subscription: ['ecommerceHostingPrices']
    // },
    {
      id: 'ecommerceOrders',
      name: 'Orders',
      icon: 'orders',
      to: '/ecommerce/orders',
      active: true,
      permission: 'web.admin.ecommerce.orders',
      subscription: ['ecommerceOrders']
    },
    {
      id: 'ecommerceSubscriptions',
      name: 'Subscriptions',
      icon: 'subscriptions',
      to: '/ecommerce/subscriptions',
      active: true,
      permission: 'web.admin.ecommerce.subscriptions',
      subscription: ['ecommerceSubscriptions']
    },
    {
      id: 'uptimeGuarantee',
      name: 'Uptime Guarantee',
      icon: 'uptimeGuarantee',
      to: '/ecommerce/uptime-guarantee',
      active: true,
      permission: 'web.admin.ecommerce.uptimeGuarantee',
      subscription: ['ecommerceUptimeGuarantee']
    },
    {
      id: 'hashpower',
      name: 'Hashpower',
      icon: 'cloud',
      active: true,
      permission: 'web.admin.products.hashpower',
      subscription: ['hashpowerOrders', 'hashpowerPrices', 'hashpowerCapacity'],
      children: [
        {
          id: 'hashpowerOrders',
          name: 'Orders',
          to: '/hashpower/orders',
          active: true,
          permission: 'web.admin.products.hashpower.orders',
          subscription: ['hashpowerOrders']
        },
        {
          id: 'hashpowerPrices',
          name: 'Prices',
          to: '/hashpower/prices',
          active: true,
          permission: 'web.admin.products.hashpower.prices',
          subscription: ['hashpowerPrices']
        },
        {
          id: 'hashpowerCapacity',
          name: 'Capacity',
          to: '/hashpower/capacity',
          active: true,
          permission: 'web.admin.products.hashpower.capacity',
          subscription: ['hashpowerCapacity']
        }
      ]
    }
    // {
    //   id: 'buyHost',
    //   name: 'Buy & Host',
    //   icon: 'hardDrives',
    //   active: true,
    //   permission: 'web.admin.products.buyHost',
    //   subscription: [
    //     'buyHostInventory',
    //     'buyHostOrders',
    //     'buyHostMinerReturn',
    //     'buyHostHostingPrices'
    //   ],
    //   children: [
    // {
    //   id: 'buyHostHostingPrices',
    //   name: 'Hosting Prices',
    //   to: '/buy-host/hosting-prices',
    //   active: true,
    //   permission: 'web.admin.products.buyHost.hostingPrices',
    //   subscription: ['buyHostHostingPrices']
    // },
    // {
    //   id: 'buyHostInventory',
    //   name: 'Inventory',
    //   to: '/products/inventory',
    //   active: true,
    //   permission: 'web.admin.products.buyHost.inventory',
    //   subscription: ['buyHostInventory']
    // }
    // {
    //   id: 'buyHostOrders',
    //   name: 'Orders',
    //   to: '/buy-host/orders',
    //   active: true,
    //   permission: 'web.admin.products.buyHost.orders',
    //   subscription: ['buyHostOrders']
    // },
    // {
    //   id: 'buyHostMinerReturn',
    //   name: 'Miner Return',
    //   to: '/buy-host/miner-return',
    //   active: true,
    //   permission: 'web.admin.products.buyHost.minerReturn',
    //   subscription: ['buyHostMinerReturn']
    // }
    // ]},
    // {
    //   id: 'minerHosting',
    //   name: 'Miner Hosting',
    //   icon: 'hardDrive',
    //   active: true,
    //   permission: 'web.admin.products.minerHosting',
    //   subscription: [
    //     'minerHostingPrices',
    //     'minerHostingTypes',
    //     'minerHostingOrders',
    //     'minerHostingMinerReturn'
    //   ],
    //   children: [
    //     {
    //       id: 'minerHostingPrices',
    //       name: 'Hosting Prices',
    //       to: '/miner-hosting/hosting-prices',
    //       active: true,
    //       permission: 'web.admin.products.minerHosting.hostingPrices',
    //       subscription: ['minerHostingPrices']
    //     }
    // {
    //   id: 'minerHostingTypes',
    //   name: 'Active Miner Types',
    //   to: '/miner-hosting/types',
    //   active: true,
    //   permission: 'web.admin.products.minerHosting.types',
    //   subscription: ['minerHostingTypes']
    // },
    // {
    //   id: 'minerHostingOrders',
    //   name: 'Orders',
    //   to: '/miner-hosting/orders',
    //   active: true,
    //   permission: 'web.admin.products.minerHosting.orders',
    //   subscription: ['minerHostingOrders']
    // },
    // {
    //   id: 'minerHostingMinerReturn',
    //   name: 'Miner Return',
    //   to: '/miner-hosting/miner-return',
    //   active: true,
    //   permission: 'web.admin.products.minerHosting.minerReturn',
    //   subscription: ['minerHostingMinerReturn']
    // }
    //   ]
    // },
    // {
    //   id: 'subscriptions',
    //   name: 'Subscriptions',
    //   icon: 'bookmarks',
    //   active: true,
    //   permission: 'web.admin.products.subscriptions',
    //   subscription: ['duckEnergyPro', 'extraInsurance'],
    //   children: [
    //     {
    //       id: 'duckEnergyPro',
    //       name: 'DuckEnergy Pro',
    //       to: '/subscriptions/duckenergy-pro',
    //       active: true,
    //       permission: 'web.admin.products.subscriptions.duckEnergyPro',
    //       subscription: ['duckEnergyPro']
    //     },
    //     {
    //       id: 'extraInsurance',
    //       name: 'Extra Insurance',
    //       to: '/subscriptions/extra-insurance',
    //       active: true,
    //       permission: 'web.admin.products.subscriptions.extraInsurance',
    //       subscription: ['extraInsurance']
    //     }
    //   ]
    // }
  ]
};

export const marketingRoutes = {
  label: 'Marketing',
  permission: 'web.admin.marketing',
  children: [
    {
      id: 'marketingUserAnalytics',
      name: 'User Analytics',
      to: '/marketing/user-analytics',
      icon: 'userAnalytics',
      active: true,
      permission: 'web.admin.marketing.userAnalytics',
      subscription: ['marketingUserAnalytics']
    },
    {
      id: 'marketingBirthdays',
      name: 'Birthdays',
      to: '/marketing/birthdays',
      icon: 'birthdays',
      active: true,
      permission: 'web.admin.marketing.birthdays',
      subscription: ['marketingBirthdays']
    },
    {
      id: 'marketingMailCampaigns',
      name: 'Mail Campaigns',
      to: '/marketing/mail-campaigns',
      icon: 'marketingCampaigns',
      active: true,
      permission: 'web.admin.marketing.mailCampaigns',
      subscription: ['marketingMailCampaigns']
    },
    {
      id: 'newsletter',
      name: 'Newsletter',
      to: '/marketing/newsletter',
      icon: 'newsletter',
      active: true,
      permission: 'web.admin.marketing.newsletter',
      subscription: ['newsletter']
    },
    {
      id: 'marketingPopups',
      name: 'Pop-ups',
      to: '/marketing/pop-ups',
      icon: 'marketingPopups',
      active: true,
      permission: 'web.admin.marketing.popups',
      subscription: ['marketingPopups']
    },
    {
      id: 'marketingLandingPage',
      name: 'Landing Page',
      to: '/marketing/landing-page',
      icon: 'landingPage',
      active: true,
      permission: 'web.admin.marketing.landingPage',
      subscription: ['marketingLandingPage']
    },
    {
      id: 'marketingGoogleAnalytics',
      name: 'Google Analytics',
      to: '/marketing/google-analytics',
      icon: 'analytics',
      active: true,
      permission: 'web.admin.marketing.googleAnalytics',
      subscription: ['marketingGoogleAnalytics']
    },
    {
      id: 'marketingSimilarweb',
      name: 'SimilarWeb',
      to: '/marketing/similarweb',
      icon: 'similarWeb',
      active: true,
      permission: 'web.admin.marketing.similarweb',
      subscription: ['marketingSimilarweb']
    }
  ]
};

export const connectRoutes = {
  label: 'Connect',
  permission: 'web.admin.connect',
  children: [
    {
      id: 'connectOverview',
      name: 'Overview',
      to: '/connect/overview',
      icon: 'uniteSquare',
      active: true,
      permission: 'web.admin.connect.overview',
      subscription: ['connectOverview']
    },
    {
      id: 'buyMarketplace',
      name: 'Buy Marketplace',
      to: '/connect/buy-marketplace',
      icon: 'shoppingCart',
      active: true,
      permission: 'web.admin.connect.buy',
      subscription: ['buyMarketplace']
    },
    {
      id: 'sellMarketplace',
      name: 'Sell Marketplace',
      to: '/connect/sell-marketplace',
      icon: 'tag',
      active: true,
      permission: 'web.admin.connect.sell',
      subscription: ['sellMarketplace']
    }
  ]
};

export const downloadsRoutes = {
  functionRoute: true,
  requiredElements: ['locations'],
  route: locations => ({
    label: 'Downloads',
    permission: 'web.admin.downloads',
    children: [
      {
        id: 'downloadsInvoices',
        name: 'Invoices',
        icon: 'receipt',
        to: '/downloads/invoices',
        active: true,
        permission: 'web.admin.downloads.invoices',
        subscription: ['downloadsInvoices']
      },
      {
        id: 'downloadsContracts',
        name: 'Contracts',
        icon: 'contracts',
        to: '/downloads/contracts',
        active: true,
        permission: 'web.admin.downloads.contracts',
        subscription: ['downloadsContracts']
      },
      {
        id: 'downloadsOrders',
        name: 'Orders',
        icon: 'clipboardText',
        to: '/downloads/orders',
        active: true,
        permission: 'web.admin.downloads.orders',
        subscription: ['downloadsOrders']
      },
      {
        id: 'downloadsTotalConsumptions',
        name: 'Total Consumptions',
        icon: 'lightning',
        active: true,
        permission: 'web.admin.downloads.consumption',
        subscription: [
          'downloadsTotalConsumptionsAllLocations',
          ...locations.map(
            ({ name }) =>
              `downloadsTotalConsumptionsAllLocations-${name.toLowerCase()}`
          )
        ],
        children: [
          {
            id: 'downloadsTotalConsumptionsAllLocations',
            name: 'All Locations',
            to: '/downloads/total-consumptions/all-locations',
            permission: 'web.admin.downloads.consumption.allLocations',
            subscription: ['downloadsTotalConsumptionsAllLocations']
          },
          ...locations.map(({ id, name }) => {
            return {
              id: id,
              name: name,
              to: `/downloads/total-consumptions/${id}`,
              exact: true,
              active: true,
              permission: 'web.admin.downloads.consumption.location',
              subscription: [id]
            };
          })
        ]
      },
      {
        id: 'downloadsRevenue',
        name: 'Revenue',
        icon: 'coinVertical',
        to: '/downloads/revenue',
        active: true,
        permission: 'web.admin.downloads.revenue',
        subscription: ['downloadsRevenue']
      },
      {
        id: 'downloadsSubscriptions',
        name: 'Subscriptions',
        icon: 'sidebar',
        to: '/downloads/subscriptions',
        active: true,
        permission: 'web.admin.downloads.subscriptions',
        subscription: ['downloadsSubscriptions']
      },
      {
        id: 'downloadsPool',
        name: 'Pool',
        icon: 'chartBar',
        to: '/downloads/pool',
        active: true,
        permission: 'web.admin.downloads.pool',
        subscription: ['downloadsPool']
      }
    ]
  })
};

export const settingsRoutes = {
  label: 'Settings',
  permission: 'web.admin.settings',
  children: [
    {
      id: 'settingsBranding',
      name: 'Branding',
      icon: 'gear',
      to: '/settings/branding',
      active: true,
      permission: 'web.admin.settings.branding',
      subscription: ['settingsBranding']
    },
    {
      id: 'settingsMonitoring',
      name: 'Monitoring',
      icon: 'notification',
      to: '/settings/monitoring',
      active: true,
      permission: 'web.admin.settings.monitoring',
      subscription: ['settingsMonitoring']
    },
    {
      id: 'settingsParameters',
      name: ' Parameters',
      icon: 'gear',
      to: '/settings/parameters',
      active: true,
      permission: 'web.admin.settings.Parameters',
      subscription: ['settingsParameters']
    }
    // {
    //   id: 'settingsSeo',
    //   name: 'SEO',
    //   icon: 'devices',
    //   to: '/settings/seo',
    //   active: true,
    //   permission: 'web.admin.settings.seo',
    //   subscription: ['settingsSeo']
    // }
  ]
};

// export const saasAdminTenants = {
//   functionRoute: true,
//   requiredElements: ['tenants'],
//   route: tenants => ({
//     label: 'tenants',
//     permission: 'web.admin.tenants',
//     children: [
//       {
//         id: 'tenantsOverview',
//         name: 'Overview',
//         to: '/tenants/overview',
//         icon: 'chartPie',
//         exact: true,
//         active: true,
//         permission: 'web.admin.tenants.overview',
//         subscription: ['tenantsOverview']
//       },
//       ...tenants.map(({ id, name }) => ({
//         id,
//         name,
//         to: `/dashboard/${id}`,
//         exact: true,
//         active: true,
//         icon: name?.toLowerCase(),
//         subscription: [id],
//         permission: 'web.admin.tenants.tenant'
//       })),
//       {
//         id: 'tenantsOnboard',
//         name: 'Onboard',
//         to: '/tenants/onboard',
//         icon: 'userPlus',
//         exact: true,
//         active: true,
//         subscription: ['tenantsOnboard'],
//         permission: 'web.admin.tenants.onboard'
//       }
//     ]
//   })
// };

// Colo (Plan 06 Task 3). 'coloFlags' is always present (it's how an admin turns colo ON in the
// first place); the other three children are pruned in NavbarVertical.js when colo is not
// enabled for the org — see the featureFilteredRoutes step there.
export const coloRoutes = {
  label: 'AI',
  permission: 'web.admin.colo',
  children: [
    {
      id: 'coloFlags',
      name: 'Flags',
      icon: 'gear',
      to: '/colo/flags',
      active: true,
      permission: 'web.admin.colo.flags',
      subscription: ['coloFlags']
    },
    {
      id: 'coloSources',
      name: 'Sources',
      icon: 'network',
      to: '/colo/sources',
      active: true,
      permission: 'web.admin.colo.sources',
      subscription: ['coloSources']
    },
    {
      id: 'coloOutlets',
      name: 'Outlets',
      icon: 'sidebar',
      to: '/colo/outlets',
      active: true,
      permission: 'web.admin.colo.outlets',
      subscription: ['coloOutlets']
    },
    {
      id: 'coloForeman',
      name: 'Foreman Status',
      icon: 'network',
      to: '/colo/foreman',
      active: true,
      permission: 'web.admin.colo.sources',
      subscription: ['coloSources']
    },
    {
      id: 'coloCollectors',
      name: 'Collectors',
      icon: 'squaresFour',
      to: '/colo/collectors',
      active: true,
      permission: 'web.admin.colo.collectors',
      subscription: ['coloCollectors']
    }
  ]
};

export default [
  homeRoutes,
  // saasAdminTenants,
  customersRoutes,
  hardwareRoutes,
  tasksRoutes,
  selfMining,
  ecommerceRoutes,
  marketingRoutes,
  connectRoutes,
  downloadsRoutes,
  coloRoutes,
  settingsRoutes
];
